import toast from "react-hot-toast";
import "./subscriptionForm.scss";
import { useUpdateSubscriptionMutation } from "../../../features/api/subscriptionApiSlice";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { useVideo } from "../../../hooks/useVideo";

// ✅ Validation Schema
const SubscriptionSchema = Yup.object().shape({
  plan: Yup.string()
    .oneOf(["Basic", "Standard", "Premium"], "Invalid plan selected")
    .required("Please select a subscription plan."),
});

const SubscriptionForm = ({ subscription }) => {
  const { formatDate } = useVideo();
  const [updateSubscription, { isLoading }] = useUpdateSubscriptionMutation();
  return (
    <Formik
      initialValues={{
        plan: subscription?.type || "Basic",
      }}
      validationSchema={SubscriptionSchema}
      onSubmit={async (values, { setSubmitting }) => {
        try {
          await updateSubscription({
            id: subscription?._id,
            plan: values.plan,
          }).unwrap();
          toast.success("Subscription updated successfully!");
        } catch (err) {
          toast.error(err?.data?.message || "Failed to update subscription");
        } finally {
          setSubmitting(false);
        }
      }}
    >
      {({ isSubmitting, errors, touched }) => (
        <Form className="subscription-form">
          <div className="form-controls">
            <div>
              <p>Status: {subscription?.status}</p>
              <p>Ends/Renews: {formatDate(subscription?.expirationDate)}</p>
            </div>

            <label htmlFor="plan">
              Subscription Plan{" "}
              <span className="required-inputs" aria-label="required">
                *
              </span>
            </label>
            <Field
              as="select"
              id="plan"
              name="plan"
              className={errors.plan && touched.plan ? "input-error" : ""}
            >
              <option value="Basic">Basic - $9.99</option>
              <option value="Standard">Standard - $19.99</option>
              <option value="Premium">Premium - $29.99</option>
            </Field>
            <ErrorMessage name="plan" component="span" className="error" />
          </div>

          <button
            type="submit"
            className="save-button"
            disabled={isSubmitting || isLoading}
          >
            {isSubmitting || isLoading ? "Saving..." : "Save Subscription"}
          </button>
        </Form>
      )}
    </Formik>
  );
};

export default SubscriptionForm;
